/* eslint-disable indent */
/* eslint-disable import/no-extraneous-dependencies */
import HttpService from '@pingum/api-services/HttpService';
import AuthService from '@pingum/api-services/AuthService';
import axios from 'axios';
import { getTenantFromUrl } from '../../utils/urlHelper';

export default class BillableService {
  static getBillablesPath(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate, page, size, sort) {
    return encodeURI(`/?horseIds=${horseIds}&barnUserIds=${barnUserIds}&locationId=${locationId || ''}&taskTypeId=${taskTypeId || ''}&note=${note || ''}&status=${status}&startDate=${startDate === null
      ? ''
      : startDate.toISOString()}&endDate=${endDate
        ? endDate.toISOString()
        : ''}&page=${page}&size=${size}${sort}`);
  }

  static getBillablesExportPath(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate) {
    return encodeURI(`/export?horseIds=${horseIds}&barnUserIds=${barnUserIds}&locationId=${locationId || ''}&taskTypeId=${taskTypeId || ''}&note=${note || ''}&status=${status}&startDate=${startDate === null
      ? ''
      : startDate.toISOString()}&endDate=${endDate
        ? endDate.toISOString()
        : ''}`);
  }

  static getBillables(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate, page, size, sort) {
    const http = axios.create({
      baseURL: `${typeof window !== 'undefined'
        ? env.REACT_APP_HORSE_API
        : ''}/billables`,
      headers: {
        'content-type': 'application/json',
        'X-Tenant': getTenantFromUrl(),
        authorization: `Bearer ${AuthService.getToken()}`,
      },
    });

    return new Promise((resolve) => {
      http.get(this.getBillablesPath(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate, page, size, sort))
        .then((response) => {
          resolve(response);
        });
    });
  }

  static exportBillables(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate) {
    const http = axios.create({
      baseURL: `${typeof window !== 'undefined'
        ? env.REACT_APP_HORSE_API
        : ''}/billables`,
      headers: {
        accept: 'text/csv',
        'X-Tenant': getTenantFromUrl(),
        authorization: `Bearer ${AuthService.getToken()}`,
      },
      responseType: 'blob',
    });

    return new Promise((resolve, reject) => {
      http.get(this.getBillablesExportPath(horseIds, barnUserIds, locationId, taskTypeId, note, status, startDate, endDate))
        .then((response) => {
          resolve(response);
        }, (error) => reject(error));
    });
  }

  static getRepeatingBillables(horseIds, barnUserIds, locationId, taskTypeId, page, size, sort) {
    const http = axios.create({
      baseURL: `${typeof window !== 'undefined'
        ? env.REACT_APP_HORSE_API
        : ''}/billables`,
      headers: {
        'content-type': 'application/json',
        'X-Tenant': getTenantFromUrl(),
        authorization: `Bearer ${AuthService.getToken()}`,
      },
    });

    return new Promise((resolve) => {
      http.get(encodeURI(`/repeating?horseIds=${horseIds}&barnUserIds=${barnUserIds}&locationId=${locationId || ''}&taskTypeId=${taskTypeId || ''}&page=${page}&size=${size}${sort}`))
        .then((response) => {
          resolve(response);
        });
    });
  }

  static getBillablesAnalytics(horseIds, locationId, taskTypeId, groupBy, startDate, endDate) {
    return new Promise((resolve) => {
      this.httpService.get(encodeURI(`/analytics?horseIds=${horseIds}&locationId=${locationId || ''}&taskTypeId=${taskTypeId || ''}&groupBy=${groupBy}&startDate=${startDate === null
        ? ''
        : startDate.toISOString()}&endDate=${endDate
          ? endDate.toISOString()
          : ''}`))
        .then((response) => {
          resolve(response);
        });
    });
  }

  static deleteBillable(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Billable ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.delete(`/${id}`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static getInvoicesForBillable(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Billable ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.get(`/${id}/invoices`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static updateBillable(id, request) {
    if (!id) {
      return Promise.reject(new Error('Missing Billable ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/${id}`, request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static bulkUpdateBillable(locationId, horseIds, newStatus, startDate, endDate, taskTypeId) {
    if (!newStatus) {
      return Promise.reject(new Error('Missing Billable Status'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/update?horseIds=${horseIds}&locationId=${locationId || ''}&newStatus=${newStatus}&startDate=${startDate === null
        ? ''
        : startDate.toISOString()}&endDate=${endDate
          ? endDate.toISOString()
          : ''}&taskTypeId=${taskTypeId || ''}`, {}).then((response) => {
            resolve(response);
          }, (error) => reject(new Error(error.data.message)));
    });
  }
}

BillableService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_HORSE_API
    : ''}/billables`,
});
